export const getClaimManagementListApi=(params,query)=>{
    const queryString = new URLSearchParams(query).toString();
    return `/lease/${params}/claim/management/${queryString?`?${queryString}`:""}`
}
export const getFleetClaimManagementListApi=(params,query)=>{
    const queryString = new URLSearchParams(query).toString();
    return `/claims/${queryString ? `?${queryString}` : ""}`
}
export const exportFleetClaimsApi=()=>{
    return `/claims/export/`
}

export const exportClaimManagementApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/claims/export/${queryString ? `?${queryString}` : ""}`
}

export const getAssetDropdowmListApi=()=>{
    return `/get-asset-dropdown-list/`
}